import { useEffect, useState } from "react";
import { Button, Col, Image, Row } from "react-bootstrap";
import BlackLOGO from "../../assets/images/CD-Valet-Black.svg";
import ButtonIcon from "../../assets/images/ViewButton copy.svg";
import XOutline from "../../assets/images/XOutline.svg";
import { trackEvent } from "../../utils/analytics";
import { clickTrack, legalType, redirectToNewTab } from "../../utils/common";
import {
  ELIGIBAL_CONTENT,
  ELIGIBAL_ERROR,
  MARKETING_COMMUNICATIONS,
  MODAL_ELIGIBAL,
  MODAL_HEADING,
  MODAL_INELIGIBAL,
  PRIVACY_POLICY,
} from "../../utils/constant";
import { getDecodedCookie } from "../../utils/cookiesUtils";
import { apiFetch } from "../ApiCall";
import BTButtonWithLoader from "../BTButtonWithLoader";
import CommonModal from "../CommonModal";
import CheckboxForm from "../DynamicForm/CheckboxForm";
import DropDownForm from "../DynamicForm/DropDownForm";
import EmailForm from "../DynamicForm/EmailForm";
import FirstNameForm from "../DynamicForm/FirstNameForm";
import LastNameForm from "../DynamicForm/LastNameForm";
import PhoneNumberForm from "../DynamicForm/PhoneNumberForm";
import RadioForm from "../DynamicForm/RadioForm";
import TermForm from "../DynamicForm/TermsForm";
import TextForm from "../DynamicForm/TextForm";
import InterstitialThankPopUp from "../InterstitialThankPopUp";
import Loader from "../Loader";
import { OpenNowWrapper, redirectToLoader } from "./OpenNowButtonComponent";

const OpenNowButton = ({ Apply, placeSource = "", affiliateId }) => {
  const [LeadLinkModalShow, setLeadLinkModalShow] = useState(false);
  const [formQuestions, setFormQuestion] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [cdTerms, setCdTerms] = useState({});
  const [termInfo, setTermInfo] = useState([]);
  const [isButtonLoading, setIsButtonLoading] = useState(false);
  const [isEligibleDisplay, setIsEligibleDisplay] = useState(false);
  const [isEligibleError, setIsEligibleError] = useState(false);
  const [displayFieldIndex, setDisplayFieldIndex] = useState(-1);
  const [isTermsChecked, setIsTermsChecked] = useState(false);
  const [isChecked, setIsChecked] = useState(1);
  const [interstitialShow, setInterstitialShow] = useState(false);
  const subscribeEmail =
    typeof document !== "undefined" ? getDecodedCookie("email") : "";
  const Email = subscribeEmail || "";
  const keyParams = ["firstName", "lastName", "email"];

  const OpenNowGAData = {
    apy: Apply?.apy,
    url: Apply?.url,
    terms: Apply?.terms,
    bankId: Apply?.bankId,
    cdId: Apply?._id,
    source: "",
    placeSource,
    bankName: Apply?.bankName,
    bankType: Apply?.bankType || Apply?.type,
    legal: legalType(Apply?.bankType),
    isIRA: "false",
    actionUrl: Apply?.actionUrl,
    maxBalance: Apply?.maxBalance,
    minBalance: Apply?.minBalance,
    consent: isChecked,
    applyAction: Apply?.applyAction,
    charterState: Apply?.charterState || Apply?.bankCharterState,
    termInMonths: Apply?.termInMonths,
    affiliateId,
  };

  const handleLeadLinkModalClose = (e) => {
    e.stopPropagation();
    setIsChecked(1);
    setLeadLinkModalShow(false);
    setFormQuestion([]);
    setCdTerms("");
    setTermInfo([]);
    setIsLoading(false);
    setIsTermsChecked(false);
    setIsButtonLoading(false);
    setIsEligibleError(false);
    setIsEligibleDisplay(false);
  };

  const validateAmount = () => {
    let isValid = false;
    const termSelected = formQuestions?.find(
      (item) => item?.inputType === "terms"
    );
    if (termSelected) {
      const minBal = parseFloat(termSelected?.minBalance);
      const maxBal = parseFloat(termSelected?.maxBalance);
      const cdAmount = parseFloat(termSelected?.userInput?.cdAmount);

      if (
        (minBal <= cdAmount && maxBal >= cdAmount && maxBal > 0) ||
        (minBal <= cdAmount && maxBal === 0)
      ) {
        isValid = true;
      } else {
        isValid = false;
      }
    }
    return isValid;
  };

  const openConfirmationModal = (e,setLoading) => {
    e.stopPropagation();
    setIsChecked(1);
    // sendTelemetry();
    const isLimitedOffer = placeSource === "Limited offers";
    const params = {
      ...OpenNowGAData,
      ...(isLimitedOffer && { limitedOfferId: Apply.limitedOfferId }),
    };
    const logEventsData = {
      bankId: OpenNowGAData.bankId,
      ...params,
      ...(isLimitedOffer && { isLimitedOfrPgEvent: true }),
    };
    trackEvent("Affiliate_Open_Now_Action", {
      ...logEventsData,
      affiliateId,
    });
      redirectToLoader(Apply,setLoading);
  };

  useEffect(() => {
    if (LeadLinkModalShow) {
      apiFetch(`/api/v1/bank/rates/${Apply?.bankId}`, "GET", null, {
        "Content-Type": "application/json",
      })
        .then((res) => {
          let responseData = [];
          responseData =
            Apply?.bankFormEnabled === 1
              ? res?.data
              : res?.data?.filter((item) => item?.cdFormEnabled === 1);
          setTermInfo(responseData);
          let termData = responseData?.find((term) => term?._id === cdTerms);
          if (termData) {
            setCdTerms(termData);
          } else {
            termData = responseData[0];
            setCdTerms(termData);
          }
        })
        .catch((error) => {
          console.error("Error fetching terms:", error);
        });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [LeadLinkModalShow]);

  // Get Question's logic
  const fetchData = (Apply) => {
    setIsLoading(true);
    apiFetch(`/api/v1/form/get/${Apply?.bankId}`, "GET", null, {
      "Content-Type": "application/json",
    }).then((res) => {
      if (res?.code === 200) {
        const formFields = res?.data[0]?.formFields || [];
        if (formFields.length > 0) {
          const mappedFields = formFields.map((item) => {
            const inputMap = {
              firstName: "",
              lastName: "",
              phone: "",
              email: Email,
            };

            const preFilledValue = inputMap[item?.inputType] ?? "";

            // Determine validation state
            let validationError = false;
            if (item?.isRequired) {
              validationError = !preFilledValue;
            }

            // Special case for terms
            if (item?.inputType === "terms") {
              return {
                ...item,
                userInput: "",
                selectedTerm: { _id: Apply?.cdId || Apply?._id },
                validationError: true,
              };
            }

            return {
              ...item,
              userInput: preFilledValue,
              validationError,
            };
          });

          setFormQuestion(mappedFields);

          const EligibleItem = formFields.find((item) => item?.isEligibal);
          const nonEligibleItem = formFields.find((item) => !item?.isEligibal);
          setIsEligibleDisplay(!!EligibleItem);

          if (!EligibleItem && !nonEligibleItem) {
            setIsLoading(false);
            setLeadLinkModalShow(false);
            redirectToLoader(Apply);
          } else {
            // setSubmitDisabled(false);
          }

          setIsLoading(false);
        } else {
          setLeadLinkModalShow(false);
          redirectToLoader(Apply);
        }
      } else {
        setLeadLinkModalShow(true);
        setIsTermsChecked(false);
      }
    });
  };

  useEffect(() => {
    if (cdTerms) {
      validateAmount();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cdTerms]);

  const GaApplyData = {
    city: Apply?.city,
    url: Apply?.url,
    // user: Apply?.user,
    bankId: Apply?.bankId,
    // cdId: Apply?._id, // Do not remove
    website: Apply?.website,
    bankName: Apply?.bankName,
    bank: Apply?.bankName,
    bankType: Apply?.bankType,
    legal: legalType(Apply?.bankType),
    actionUrl: Apply?.actionUrl,
    consent: isChecked,
    isIRA: Apply?.isIRA === 0 ? "false" : "true",
    privacyUrl: Apply?.privacyUrl,
    minBalance: Apply?.minBalance,
    maxBalance: Apply?.maxBalance,
    openNowUrl: Apply?.openNowUrl,
    applyAction: Apply?.applyAction,
    charterState: Apply?.charterState || Apply?.bankCharterState,
    cdFormEnabled: Apply?.cdFormEnabled || Apply?.bankFormEnabled,
    bankFormEnabled: Apply?.bankFormEnabled,
    ...(Apply?.limitedOfferId
      ? { limitedOfferId: Apply?.limitedOfferId }
      : { cdId: Apply?._id }),
  };

  // submit Form Data
  const handleSubmit = (Apply) => {
    let cdTerms;
    const isValidForm = true;
    const gaEventData = {};
    const formFieldsParam = [];
    const params = { ...GaApplyData };
    for (const index in formQuestions) {
      const questions = formQuestions[index];
      if (questions?.inputType === "phone") {
        params[questions?.inputType] = questions?.userInput?.substr(
          questions?.userInput?.length - 10
        );
        gaEventData[questions?.inputType] = questions?.userInput?.substr(
          questions?.userInput?.length - 10
        );
      } else if (keyParams?.includes(questions?.inputType)) {
        params[questions?.inputType] = questions?.userInput;
        gaEventData[questions?.inputType] = questions?.userInput;
      } else if (questions.inputType === "terms") {
        const { apy, terms, termInMonths } = questions?.selectedTerm;
        cdTerms = questions?.selectedTerm;
        params.cdAmount = questions?.userInput;
        params.cdTerms =
          questions?.selectedTerm?.showTerms || terms || termInMonths;
        params.apy = questions?.selectedTerm?.apy;
        params.label = questions?.selectedTerm?.label;
        params[Apply?.limitedOfferId ? "limitedOfferId" : "cdId"] =
          Apply?.limitedOfferId ? Apply?.limitedOfferId : Apply?._id;

        // ga event data set of terms
        gaEventData.cdId = questions?.selectedTerm?._id;
        gaEventData.cdAmount = questions?.userInput;
        gaEventData.cdTerms = questions?.selectedTerm?.showTerms;
        gaEventData.apy = questions?.selectedTerm?.apy;
      } else {
        formFieldsParam.push({
          fieldText: questions?.question,
          userInput:
            questions?.validationType === "phone"
              ? questions?.userInput.replace(/[()-\s]/g, "")
              : questions?.userInput,
        });
      }
    }
    if (!isValidForm) return;
    setIsButtonLoading(true);

    const submitInfo = { ...params, formData: formFieldsParam };
    Object.keys(params).forEach((key) => {
      gaEventData[key] = params[key];
    });
    // ga event pass data
    formFieldsParam.forEach((item) => {
      gaEventData[item?.fieldText] = item?.userInput;
    });
    gaEventData["source"] = "";
    apiFetch("/api/v1/form/submit", "POST", submitInfo, {
      "Content-Type": "application/json",
    }).then((res) => {
      setIsLoading(false);
      if (res?.code === 200) {
        const isLimitedOffer = placeSource === "Limited offers";
        const params = {
          ...gaEventData,
          ...(isLimitedOffer && { limitedOfferId: Apply.limitedOfferId }),
        };
        const logEventsData = {
          bankId: gaEventData.bankId,
          params,
          ...(isLimitedOffer && { isLimitedOfrPgEvent: true }),
          affiliateId,
        };
        trackEvent("Affiliate_lead_form_submit_Action", logEventsData);
        setLeadLinkModalShow(false);
        setIsLoading(false);
        if (
          Apply?.applyAction === 1 &&
          (Apply?.openNowUrl === "" || Apply?.actionUrl === "")
        ) {
          setInterstitialShow(true);
        } else if (
          Apply?.applyAction !== 1 &&
          (Apply?.openNowUrl !== "" || Apply?.actionUrl !== "")
        ) {
          setTimeout(() => {
            setInterstitialShow(false);
          }, 3000);
          setInterstitialShow(true);
        }
        setTimeout(() => {
          let openURL = Apply?.openNowUrl
            ? Apply?.openNowUrl
            : Apply?.actionUrl;
          if (cdTerms) {
            openURL = cdTerms?.openNowUrl ? cdTerms?.openNowUrl : openURL;
          }
          if (openURL !== "") {
            const redirect = `url=${openURL}&&logo=${Apply?.bankLogo}&&bank=${Apply?.bankName}&&pdType=${Apply?.productType}`;
            if (Apply?.applyAction !== 1) {
              redirectToNewTab(`/openNowDetails?${redirect}`);
            }
          }
        }, 3000);
      }
      setIsButtonLoading(false);
      // setSubmitDisabled(false);
      if (res === undefined) {
        setIsLoading(false);
        setLeadLinkModalShow(false);
        setIsButtonLoading(false);
        // setSubmitDisabled(false);
      }
    });
  };

  useEffect(() => {
    if (formQuestions?.length > 0) {
      if (isEligibleDisplay) {
        const isEligblePass = formQuestions?.filter((item) => {
          if (Object?.hasOwn(item, "eligibleErr") && item?.isEligibal) {
            if (item?.eligibleErr) {
              return true;
            }
          }
          return false;
        });

        let isValid = false;
        setIsEligibleError(isEligblePass?.length > 0);
        if (isEligblePass?.length === 0) {
          const noOfEligible = formQuestions?.filter(
            (item) => item?.isEligibal
          );
          const noOfEligibleAnswer = formQuestions?.filter(
            (item) => item?.isEligibal && item?.userInput
          );
          if (noOfEligible?.length === noOfEligibleAnswer?.length) {
            setIsEligibleDisplay(false);
            // setSubmitDisabled(false);
            isValid = true;
            const nonEligbleFrm = formQuestions?.filter(
              (item) => !item?.isEligibal
            );
            if (nonEligbleFrm?.length === 0) {
              handleSubmit(Apply);
            }
          }
        }
        if (Apply?.privacyUrl && isValid) {
          if (!isTermsChecked) {
            // setSubmitDisabled(true);
          }
        }
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formQuestions]);

  const handleChange = (event, question) => {
    let itemIndex = -1;
    let isFound = false;
    let fieldIndex = 0;
    const NewFormData = formQuestions?.map((item, index) => {
      if (isFound && item?.isEligibal) {
        item = { ...item, userInput: "", eligibleErr: false };
      }
      if (question.question === item?.question) {
        item = question;
        if (!item?.userInput || item?.userInput === "") {
          item = { ...item, validationError: true };
        }
        if (item?.isEligibal) {
          itemIndex = fieldIndex - 1;
          isFound = true;
          if (!question?.eligibleErr) {
            itemIndex++;
          }
        }
      }
      if (item?.isEligibal) {
        fieldIndex++;
      }
      return item;
    });

    setDisplayFieldIndex(itemIndex);
    setFormQuestion(NewFormData);
  };

  // error button click
  const handleClick = () => {
    const params = { ...GaApplyData };
    const gaEventData = {};
    const eligibleQuestionsWithInput = formQuestions?.filter((question) => {
      return question?.isEligibal && question?.userInput?.trim() !== "";
    });

    eligibleQuestionsWithInput?.forEach((question) => {
      gaEventData[question?.question] = question?.userInput;
    });
    Object.keys(params).forEach((key) => {
      gaEventData[key] = params[key];
    });
    trackEvent("Affiliate_lead_form_inelligible_Action", {
      ...gaEventData,
      affiliateId,
    });
    setLeadLinkModalShow(false);
  };

  const handleModalClose = () => {
    trackEvent("Affiliate_interstitial_modal_close_Action", { affiliateId });
    setInterstitialShow(false);
  };

  // open customize modal
  const handleModalOpen = () => {
    const dropdowns = document.querySelectorAll(".dropdown-menu.show");
    dropdowns.forEach((dropdown) => dropdown.classList.remove("show"));
    setLeadLinkModalShow(false);
  };

  // eligibal and non-eligibal
  const modalBodyContent = (Apply) => {
    const eligibleQuestions = isEligibleDisplay
      ? formQuestions?.filter((ele) => ele?.isEligibal)
      : formQuestions?.filter((ele) => !ele?.isEligibal);

    return (
      <div className="lead-link-wrapper">
        <div className="section">
          <Row>
            <Col xs={3} lg={2} className="mx-md-2 mx-1 mb-3 mt-3">
              <Image src={Apply?.bankLogo} height={80} width={80} alt={""} />
            </Col>
            <Col xs={7} lg={8} className="align-items-center d-flex">
              <span className="heading">
                {MODAL_HEADING} <br />
                {Apply?.bankName}
              </span>
            </Col>
            <Col className="mt-3" xs={1} lg={1}>
              <Image
                src={XOutline}
                alt="close"
                className="cursor-pointer"
                width={25}
                height={20}
                onClick={(e) => handleLeadLinkModalClose(e)}
              />
            </Col>
          </Row>
        </div>
        <Loader loading={isLoading}>
          <div className="section-2 customize">
            <div className="d-block d-sm-block mb-3">
              {isEligibleDisplay ? (
                <>
                  <div className="pt-1">
                    <span className="fw-bold fs-15 eligibal">
                      Eligibility Criteria:
                    </span>
                  </div>
                </>
              ) : Apply.applyAction === 1 ? (
                <>
                  {eligibleQuestions.length > 0 ? (
                    <div className="pt-1">
                      <span className="fw-bold fs-16 eligibal">
                        {MODAL_ELIGIBAL}
                      </span>
                    </div>
                  ) : null}
                </>
              ) : (
                <>
                  {eligibleQuestions.length > 0 ? (
                    <div className="pt-1">
                      <span className="fw-bold fs-16 eligibal">
                        {MODAL_INELIGIBAL}
                      </span>
                    </div>
                  ) : null}
                </>
              )}
              {eligibleQuestions.length > 0 &&
                eligibleQuestions?.map((ele, index) => {
                  let className = "";
                  if (isEligibleDisplay) {
                    if (index === displayFieldIndex + 1) {
                      className = "mt-2 showAnimation hideAnimation";
                    } else if (index <= displayFieldIndex + 1) {
                      className = "mt-2 ";
                    } else {
                      className = "mt-2 hideAnimation";
                    }
                  }
                  return (
                    <div key={ele?._id} className={`${className}`}>
                      <div className="mt-1" key={ele?._id}>
                        <div key={ele?._id}>
                          <div className="d-flex">
                            <label className="fs-15 question mt-1">
                              {ele?.question &&
                                ele?.question?.charAt(0)?.toUpperCase() +
                                  ele?.question?.slice(1)}
                              {ele?.isRequired && (
                                <span className="text-danger">
                                  &nbsp;&#x2a;
                                </span>
                              )}{" "}
                            </label>
                          </div>
                          {ele?.inputType === "radio" && ele?.values && (
                            <RadioForm
                              element={ele}
                              handleChange={handleChange}
                            />
                          )}
                          {ele?.inputType === "checkbox" && ele?.values && (
                            <CheckboxForm
                              element={ele}
                              handleChange={handleChange}
                            />
                          )}
                          {ele?.inputType === "dropdown" && ele?.values && (
                            <DropDownForm
                              element={ele}
                              handleChange={handleChange}
                            />
                          )}
                          {ele?.inputType === "text" && (
                            <TextForm
                              element={ele}
                              handleChange={handleChange}
                            />
                          )}
                          {ele?.inputType === "firstName" && (
                            <FirstNameForm
                              element={ele}
                              handleChange={handleChange}
                            />
                          )}
                          {ele?.inputType === "lastName" && (
                            <LastNameForm
                              element={ele}
                              handleChange={handleChange}
                            />
                          )}
                          {ele?.inputType === "email" && (
                            <EmailForm
                              element={ele}
                              handleChange={handleChange}
                            />
                          )}
                          {ele?.inputType === "phone" && (
                            <PhoneNumberForm
                              element={ele}
                              handleChange={handleChange}
                            />
                          )}
                          {ele?.inputType === "terms" && (
                            <TermForm
                              element={ele}
                              termInfo={termInfo}
                              handleChange={handleChange}
                            />
                          )}
                        </div>
                      </div>
                    </div>
                  );
                })}
            </div>
            {!isEligibleDisplay && (
              <>
                <div className="mt-3 mb-3 d-flex align-items-center">
                  <input
                    type="checkBox"
                    className="form-check-input mt-0"
                    onClick={() => {
                      setIsChecked(isChecked === 0 ? 1 : 0);
                    }}
                    checked={isChecked}
                  />
                  <span className="submitNote mx-1 fs-12">
                    {MARKETING_COMMUNICATIONS}
                    {""}.
                  </span>
                </div>
              </>
            )}
            {!isEligibleDisplay && (
              <>
                {Apply?.privacyUrl &&
                Apply?.privacyUrl?.trim() !== "" &&
                eligibleQuestions.length > 0 ? (
                  <div className="mt-3 mb-3 d-flex align-items-center">
                    <input
                      type="checkBox"
                      className="form-check-input mt-0"
                      onClick={() => {
                        setIsTermsChecked(!isTermsChecked);
                      }}
                      checked={isTermsChecked}
                    />
                    <span className="submitNote mx-1 fs-12">
                      {PRIVACY_POLICY}
                      {""}
                      <a
                        target="_blank"
                        rel="noopener"
                        href={Apply?.privacyUrl}
                      >
                        Privacy Policy
                      </a>
                      .
                    </span>
                  </div>
                ) : null}
                <div className="m-1 text-center mt-3">
                  <BTButtonWithLoader
                    title={
                      Apply?.applyAction === 2 ||
                      Apply?.applyAction === 5 ||
                      Apply?.applyAction === 4
                        ? "Continue"
                        : "Submit"
                    }
                    type="button"
                    loadingTitle={"Loading..."}
                    isLoading={isButtonLoading}
                    className="w-100"
                    onClick={() => handleSubmit(Apply)}
                    isDisabled={
                      (Apply?.privacyUrl?.trim() !== "" && !isTermsChecked) ||
                      formQuestions.some(
                        (question) =>
                          question?.inputType !== "lastName" &&
                          !question?.isEligibal &&
                          ((question?.isRequired && !question?.userInput) ||
                            question?.validationError)
                      )
                    }
                  />
                </div>
              </>
            )}
            {isEligibleError && (
              <>
                <h6 className="text-danger fs-12 font-semi-bold eligibility-error">
                  {ELIGIBAL_ERROR}
                  <a className="cursor-pointer text-decoration-underline">
                    <span onClick={handleModalOpen}>
                      {" "}
                      entering your ZIP code
                    </span>
                  </a>
                  {ELIGIBAL_CONTENT}
                </h6>
                <div className="open-now-button">
                  <div className="d-flex justify-content-center">
                    <Button
                      variant="light"
                      className="d-flex text-center arrow mt-2 fs-14 font-semi-bold explore apply option arrow"
                      onClick={handleClick}
                    >
                      Explore More Rates
                      <div className="d-flex justify-content-center">
                        <Image
                          className="buttonArrow"
                          src={ButtonIcon}
                          alt="Button"
                          width={30}
                          height={20}
                        />
                      </div>
                    </Button>
                  </div>
                </div>
              </>
            )}
          </div>
          <div
            style={{
              backgroundColor: "#D7DF21",
              justifyContent: "center",
              display: "flex",
              borderRadius: "0px 0px 20px 20px",
              height: "40px",
              alignItems: "center",
            }}
          >
            <Image src={BlackLOGO} width={100} height={24} alt="CD valet" />
          </div>
        </Loader>
      </div>
    );
  };

  /* Open Now Button */
  return (
    <>
      <OpenNowWrapper openConfirmationModal={openConfirmationModal} />
      {/* Modal Open */}
      {LeadLinkModalShow && (
        <CommonModal
          handleShow={LeadLinkModalShow}
          modalClass={"openModal p-0"}
          animation={true}
          bodyClass={"awardBackground"}
          modalBody={modalBodyContent(Apply)}
        />
      )}
      {interstitialShow && (
        <InterstitialThankPopUp
          Apply={Apply}
          interstitialShow={interstitialShow}
          handleClose={handleModalClose}
        />
      )}
    </>
  );
};

export default OpenNowButton;
